import { getExclusivityBanner } from 'services/apis/exclusivity-banner';
import { GET_EXCLUSIVITY_BANNER } from 'constants/exclusivity-banner';

export const getExclusivityBannerAction = (bannerId) => ({
  type: GET_EXCLUSIVITY_BANNER,
  payload: getExclusivityBanner(bannerId),
});
